import * as React from "react";
import { forwardRef } from "react";
const SvgBarcode = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement("path", { stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M5.25 6.75v10.5M9 6.75v10.5m3-10.5v10.5m3.75-10.5v10.5m3-10.5v10.5" }));
const ForwardRef = forwardRef(SvgBarcode);
export { ForwardRef as ReactComponent };
